import { DocumentType } from '@/types/schema';

/**
 * Generated outputs that should not be reused as source documents for
 * downstream document-driven workflows.
 */
export const GENERATED_OUTPUT_DOCUMENT_TYPES: DocumentType[] = [
  DocumentType.GratDesignSummary,
  DocumentType.GeneratedPresentation,
  DocumentType.GeneratedDocument,
];

/**
 * Container documents that bundle other source documents together.
 */
export const CONTAINER_DOCUMENT_TYPES: DocumentType[] = [
  DocumentType.Binder,
  DocumentType.HouseholdExport,
];
/**
 * Documents that are not useful as source inputs for AI or generation flows.
 */
export const NON_INPUT_DOCUMENT_TYPES: DocumentType[] = [
  ...CONTAINER_DOCUMENT_TYPES,
  ...GENERATED_OUTPUT_DOCUMENT_TYPES,
];

/**
 * Documents that should not appear as selectable sources for summary-based
 * presentation pages.
 */
export const NON_SUMMARIZABLE_SOURCE_DOCUMENT_TYPES: DocumentType[] = [
  ...NON_INPUT_DOCUMENT_TYPES,
];

/**
 * Documents that should not appear in generic existing-document pickers.
 */
export const NON_SELECTABLE_EXISTING_DOCUMENT_TYPES: DocumentType[] = [
  ...NON_INPUT_DOCUMENT_TYPES,
];

/**
 * Documents that should be hidden from household document viewers when the
 * viewer is intended to show source files.
 */
export const NON_VIEWER_SOURCE_DOCUMENT_TYPES: DocumentType[] = [
  DocumentType.GeneratedPresentation,
  DocumentType.GeneratedDocument,
];

/**
 * Documents whose details page should stay in viewer mode and skip summary UI.
 */
export const VIEWER_ONLY_DOCUMENT_TYPES: DocumentType[] = [
  DocumentType.GeneratedPresentation,
  DocumentType.GratDesignSummary,
  DocumentType.Binder,
  DocumentType.HouseholdExport,
];

export function isKgv2EligibleSourceDocumentType(type: DocumentType): boolean {
  return !NON_INPUT_DOCUMENT_TYPES.includes(type);
}
